import { type FC } from 'react';

import { dibsLazyClient } from 'dibs-lazy/exports/dibsLazyClient.ts';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense.tsx';

const PdpRespSharedQrCode = dibsLazyClient(
    () => import(/* webpackChunkName: "PdpRespSharedQrCode" */ './PdpRespSharedQrCode.tsx')
);

export const PdpRespSharedQrCodeLazy: FC<{
    itemId: string | null;
    className: string;
}> = ({ itemId, className }) => (
    <ClientSuspense fallback={null}>
        <div className={className}>
            <PdpRespSharedQrCode itemId={itemId} />
        </div>
    </ClientSuspense>
);
